// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var InfoSign = function InfoSign(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.149 1.014A6.986 6.986 0 1015.134 8a6.986 6.986 0 00-6.985-6.986zm.817 11.423h-1.7V6.933h1.7zm0-7.065a.226.226 0 01-.226.226H7.487a.226.226 0 01-.226-.226V4.121a.226.226 0 01.226-.226h1.252a.226.226 0 01.226.226z"
    }))
  );
};

export default InfoSign;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/InfoSign.js
// module id = 1022
// module chunks = 0